import type { MessageMetadata } from "./message.js";

/**
 * Event handler function type for type-safe event handling
 */
export type MessageHandler<TData = unknown> = (
  data: TData,
  metadata: MessageMetadata
) => void;

/**
 * Internal event names used by EventMsg
 */
export const INTERNAL_EVENTS = {
  /** Emitted when a message is received */
  MESSAGE: "message",

  /** Emitted when connection is established */
  CONNECT: "connect",

  /** Emitted when connection is lost */
  DISCONNECT: "disconnect",

  /** Emitted on errors */
  ERROR: "error",

  /** Emitted before sending a message (debug) */
  SEND: "send",
} as const;

/**
 * Message information passed to onMessage handlers
 */
export interface MessageInfo {
  /** The event name from the message */
  eventName: string;
  /** The parsed message data */
  data: unknown;
  /** Message metadata (sender, timing, etc.) */
  metadata: MessageMetadata;
  /** Size of the raw message in bytes */
  messageSize: number;
}

/**
 * Connection statistics for monitoring
 */
export interface ConnectionStats {
  /** Total messages sent */
  messagesSent: number;

  /** Total messages received */
  messagesReceived: number;

  /** Connection uptime in milliseconds */
  uptime: number;

  /** Current connection state */
  connected: boolean;

  /** Last error timestamp */
  lastError?: Date;

  /** Average message round-trip time in milliseconds */
  averageRtt?: number;
}
